"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7718],{

/***/ 84586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _props_sx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23720);
/* harmony import */ var _props_spacing__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2349);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25522);
/* harmony import */ var _Inline__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31987);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67924);
/* harmony import */ var _utils_DropDownProvider_context__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17223);
/* harmony import */ var _Header_context__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3197);










const DropdownMenuItemLink = (param)=>{
    let { className ="" , children , onClick =()=>{} , ...props } = param;
    const { onClose  } = (0,_Header_context__WEBPACK_IMPORTED_MODULE_8__/* .useHeader */ .g)();
    const { changeCurrentAction , initialAction , currentAction  } = (0,_utils_DropDownProvider_context__WEBPACK_IMPORTED_MODULE_7__/* .useDropDown */ .v)();
    const handleClick = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((e)=>{
        changeCurrentAction(null);
        onClose();
        onClick(e);
        setTimeout(()=>{
            changeCurrentAction(initialAction);
        }, 100);
    }, [
        changeCurrentAction,
        initialAction,
        currentAction
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        isBaseClassName: false,
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_6__/* .classes */ .S)("dropdown-menu-item-link", className),
        onClick: handleClick,
        ...props,
        children: children
    });
};
DropdownMenuItemLink.propTypes = {
    ..._Link__WEBPACK_IMPORTED_MODULE_4__/* ["default"].propTypes */ .Z.propTypes,
    onClick: prop_types__WEBPACK_IMPORTED_MODULE_9__.func
};
const DropdownMenuItem = (param)=>/*#__PURE__*/ {
    let { className ="" , children , sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_2__/* .sxProps */ .ET
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_3__/* .spacingProps */ .tF
    }  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_6__/* .classes */ .S)("dropdown-menu-item", ...(0,_props_sx__WEBPACK_IMPORTED_MODULE_2__/* .sxClassName */ .ZA)(sx), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_3__/* .spacingClassName */ .RB)(spacing), className),
        children: children
    });
};
DropdownMenuItem.propTypes = {
    ..._Inline__WEBPACK_IMPORTED_MODULE_5__/* ["default"].propTypes */ .Z.propTypes
};
DropdownMenuItem.Link = DropdownMenuItemLink;
/* harmony default export */ __webpack_exports__["Z"] = (DropdownMenuItem);


/***/ }),

/***/ 25672:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Paragraph__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74229);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67924);




const HeroLead = (param)=>{
    let { className ="" , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Paragraph__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_3__/* .classes */ .S)("section-hero__lead", className),
        ...props
    });
};
HeroLead.propTypes = {
    ..._Paragraph__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propTypes */ .Z.propTypes
};
/* harmony default export */ __webpack_exports__["Z"] = (HeroLead);


/***/ }),

/***/ 88554:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ InputGroup_InputGroup; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Button/index.js + 1 modules
var Button = __webpack_require__(18774);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/InputGroup/InputGroup.js





const InputGroupPrepend = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "input-group-prepend",
        children: children
    });
};
InputGroupPrepend.propTypes = {
    children: prop_types.node.isRequired
};
const InputGroupAppend = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "input-group-append",
        children: children
    });
};
InputGroupAppend.propTypes = {
    children: prop_types.node.isRequired
};
const InputGroupField = (param)=>{
    let { children  } = param;
    return children;
};
InputGroupField.propTypes = {
    children: prop_types.node.isRequired
};
const InputGroup = (param)=>{
    let { children , className  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,classes/* classes */.S)("input-group", className),
        children: children
    });
};
InputGroup.propTypes = {
    children: prop_types.node.isRequired,
    className: prop_types.string
};
const InputGroupButton = (param)=>/*#__PURE__*/ {
    let { ...props } = param;
    return (0,jsx_runtime.jsx)(Button/* default */.Z, {
        styleType: "input-group",
        size: "s",
        ...props
    });
};
InputGroupButton.propTypes = {
    ...Button/* default.propTypes */.Z.propTypes
};
InputGroup.Prepend = InputGroupPrepend;
InputGroup.Append = InputGroupAppend;
InputGroup.Field = InputGroupField;
InputGroup.Button = InputGroupButton;
/* harmony default export */ var InputGroup_InputGroup = (InputGroup);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/InputGroup/index.js



/***/ }),

/***/ 19334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SectionTryForFree_SectionTryForFree; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Section/index.js + 1 modules
var Section = __webpack_require__(93512);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/SectionTryForFree/SectionTryForFree.js





const Title = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "section-try-for-free__title",
        children: children
    });
};
Title.propTypes = {
    children: prop_types.node.isRequired
};
const Action = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "section-try-for-free__action",
        children: children
    });
};
Action.propTypes = {
    children: prop_types.node.isRequired
};
const SectionTryForFree = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
        className: "section-try-for-free",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Container */.W2, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                px: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                    utility: {
                        position: {
                            position: "relative",
                            zIndex: 1
                        }
                    },
                    children: children
                })
            })
        })
    });
};
SectionTryForFree.propTypes = {
    children: prop_types.node.isRequired
};
SectionTryForFree.Title = Title;
SectionTryForFree.Action = Action;
/* harmony default export */ var SectionTryForFree_SectionTryForFree = (SectionTryForFree);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/SectionTryForFree/index.js



/***/ }),

/***/ 63669:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25522);





const Title = (param)=>/*#__PURE__*/ {
    let { href , children  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "tile-block__title",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            href: href,
            className: "tile-block__title-link",
            children: children
        })
    });
};
Title.propTypes = {
    href: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired,
    children: prop_types__WEBPACK_IMPORTED_MODULE_4__.node.isRequired
};
const Description = (param)=>/*#__PURE__*/ {
    let { children  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "tile-block__description",
        children: children
    });
};
Description.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_4__.node.isRequired
};
const TileBlockBody = (param)=>/*#__PURE__*/ {
    let { children  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
        auto: true,
        className: "tile-block__body",
        children: children
    });
};
TileBlockBody.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_4__.node.isRequired
};
TileBlockBody.Title = Title;
TileBlockBody.Description = Description;
/* harmony default export */ __webpack_exports__["Z"] = (TileBlockBody);


/***/ }),

/***/ 178:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10334);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67478);





const TileBlockImage = (param)=>/*#__PURE__*/ {
    let { src , alt =""  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Col */ .JX, {
        className: "tile-block__image",
        shrink: true,
        sm: 1,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            src: src,
            alt: alt
        })
    });
};
TileBlockImage.propTypes = {
    src: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired,
    alt: prop_types__WEBPACK_IMPORTED_MODULE_4__.string
};
/* harmony default export */ __webpack_exports__["Z"] = (TileBlockImage);


/***/ }),

/***/ 16887:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ TileBlock_TileBlock; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/TileBlock/TileBlock.js




const TileBlock = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "tile-block",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
            utility: {
                justify: "center"
            },
            children: children
        })
    });
};
TileBlock.propTypes = {
    children: prop_types.node.isRequired
};
/* harmony default export */ var TileBlock_TileBlock = (TileBlock);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/TileBlock/index.js



/***/ }),

/***/ 6930:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _Heading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42866);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67478);
/* harmony import */ var _Section__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93512);






const SectionSearchBar = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Section__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        className: "section-search-bar",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Container */ .W2, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Row */ .X2, {
                px: true,
                utility: {
                    justify: "center"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Col */ .JX, {
                    sm: 12,
                    md: 11,
                    lg: 8,
                    children: children
                })
            })
        })
    });
};
SectionSearchBar.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_5__.node.isRequired
};
const Title = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Heading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        Tag: "h2",
        sx: {
            fontSize: "xl",
            textAlign: "center"
        },
        spacing: {
            mt: 0,
            mb: 2
        },
        children: children
    });
};
Title.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_5__.node.isRequired
};
SectionSearchBar.Title = Title;
/* harmony default export */ __webpack_exports__["Z"] = (SectionSearchBar);


/***/ }),

/***/ 48474:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Resources; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/i18/index.js + 14 modules
var i18 = __webpack_require__(24155);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/createClient/index.js
var createClient = __webpack_require__(15959);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/PageMeta/index.js
var PageMeta = __webpack_require__(93890);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/ui/HeroBrand.js
var HeroBrand = __webpack_require__(68103);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Title.js
var Title = __webpack_require__(91319);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Lead.js
var Lead = __webpack_require__(25672);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Grid.js
var Grid = __webpack_require__(36432);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Resources/components/SectionHero/TitleSection/Graphpad.js






const HeroTitleSectionGraphpad = (param)=>{
    let { title , description  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* HeroRow */.P, {
        spacing: {
            mb: 10
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* HeroCol */.Z, {
            sm: 12,
            md: 9,
            sx: {
                textAlign: "center"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                    sx: {
                        fontColor: "white"
                    },
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Lead/* default */.Z, {
                    children: description
                })
            ]
        })
    });
};
HeroTitleSectionGraphpad.propTypes = {
    title: prop_types.node,
    description: prop_types.node
};
/* harmony default export */ var Graphpad = (HeroTitleSectionGraphpad);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Description.js
var Description = __webpack_require__(50410);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var atomic_react_Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Image/index.js + 1 modules
var Image = __webpack_require__(10334);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Resources/components/SectionHero/TitleSection/Snapgene.js






const logo = "/images/common/new-snapgene-academy-logo-dark.png";
const HeroTitleSectionSnapgene = (param)=>{
    let { description  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Row */.X2, {
                center: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Col */.JX, {
                    lg: 7,
                    sm: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: logo
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Description/* default */.Z, {
                children: description
            })
        ]
    });
};
HeroTitleSectionSnapgene.propTypes = {
    description: prop_types.node
};
/* harmony default export */ var Snapgene = (HeroTitleSectionSnapgene);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Resources/components/SectionHero/TitleSection/Omiq.js





const HeroTitleSectionOmiq = (param)=>{
    let { title , description  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Description/* default */.Z, {
                spacing: {
                    mb: 12
                },
                children: description
            })
        ]
    });
};
HeroTitleSectionOmiq.propTypes = {
    title: prop_types.node,
    description: prop_types.node
};
/* harmony default export */ var Omiq = (HeroTitleSectionOmiq);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Resources/components/SectionHero/TitleSection/Labarchives.js





const HeroTitleSectionLabarchives = (param)=>{
    let { title , description  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Description/* default */.Z, {
                children: description
            })
        ]
    });
};
HeroTitleSectionLabarchives.propTypes = {
    title: prop_types.node,
    description: prop_types.node
};
/* harmony default export */ var Labarchives = (HeroTitleSectionLabarchives);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/PageNavbar/index.js + 1 modules
var PageNavbar = __webpack_require__(11794);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/PageNavbar/Item.js
var Item = __webpack_require__(361);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Dropdown/index.js + 5 modules
var Dropdown = __webpack_require__(70097);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Dropdown/Menu.js
var Menu = __webpack_require__(36697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Dropdown/MenuItem.js
var MenuItem = __webpack_require__(84586);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Inline/index.js + 1 modules
var Inline = __webpack_require__(31987);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/utils/getContentProps.js
var getContentProps = __webpack_require__(76638);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Resources/components/SectionHero/IconSection/Snapgene.js










const HeroIconSectionSnapgene = (param)=>{
    let { items =[]  } = param;
    return items.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(PageNavbar/* default */.Z, {
        alignHorizontal: "around",
        sticky: true,
        bgColor: "2",
        utility: {
            sm: {
                display: "none"
            },
            md: {
                display: "none"
            }
        },
        children: items.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                spacing: {
                    md: {
                        py: 3
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default.Title */.Z.Title, {
                            childrenProps: {
                                utility: {
                                    display: "flex",
                                    align: {
                                        items: "center"
                                    }
                                },
                                sx: {
                                    fontColor: "white",
                                    fontSize: "l",
                                    hover: {
                                        fontColor: "3"
                                    }
                                }
                            },
                            triangleProps: {
                                size: "xl"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Inline/* default */.Z, {
                                children: item.name
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default.Body */.Z.Body, {
                            utility: {
                                bgColor: "transparent"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu/* default */.Z, {
                                shadow: false,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default.Link */.Z.Link, {
                                            className: "text-color-2 text-color-white--hover",
                                            href: "#".concat(item.id),
                                            children: "View All"
                                        })
                                    }, item.id),
                                    (item.items || []).map((subItem)=>{
                                        const { slug ="" , externalUrl =""  } = subItem;
                                        const contentProps = (0,getContentProps/* default */.Z)(subItem.sys_type, subItem.type);
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default.Link */.Z.Link, {
                                                className: "text-color-2 text-color-white--hover",
                                                href: contentProps && contentProps.alias ? "".concat(contentProps.alias, "/").concat(slug) : externalUrl,
                                                children: subItem.title
                                            })
                                        }, subItem.sys_id);
                                    })
                                ]
                            })
                        })
                    ]
                })
            }, item.id))
    });
};
HeroIconSectionSnapgene.propTypes = {
    items: (0,prop_types.arrayOf)((0,prop_types.shape)({
        blockOrder: prop_types.number,
        id: prop_types.string,
        name: prop_types.string,
        items: (0,prop_types.arrayOf)((0,prop_types.shape)({
            title: prop_types.string,
            url: prop_types.string,
            externalUrl: prop_types.string,
            slug: prop_types.string,
            type: prop_types.string,
            sys_id: prop_types.string
        }))
    }))
};
/* harmony default export */ var IconSection_Snapgene = (HeroIconSectionSnapgene);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Block/index.js + 1 modules
var Block = __webpack_require__(6949);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Resources/components/SectionHero/IconSection/Omiq.js











const HeroIconSectionOmiq = (param)=>{
    let { items =[]  } = param;
    if (items.length === 0) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageNavbar/* default */.Z, {
        alignHorizontal: "between",
        sticky: true,
        bgColor: "white",
        utility: {
            sm: {
                display: "none"
            },
            md: {
                display: "none"
            }
        },
        fullWidthBorder: true,
        children: items.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Block/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                    spacing: {
                        md: {
                            py: 3
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default.Title */.Z.Title, {
                                childrenProps: {
                                    utility: {
                                        display: "flex",
                                        align: {
                                            items: "center"
                                        }
                                    },
                                    sx: {
                                        hover: {
                                            fontColor: "2"
                                        }
                                    }
                                },
                                triangleProps: {
                                    size: "xl",
                                    isOpenColor: "2"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Inline/* default */.Z, {
                                    children: item.name
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default.Body */.Z.Body, {
                                utility: {
                                    bgColor: "transparent"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default.Link */.Z.Link, {
                                                sx: {
                                                    fontColor: "2",
                                                    hover: {
                                                        fontColor: "white",
                                                        bgColor: "2"
                                                    }
                                                },
                                                href: "#".concat(item.id),
                                                children: "View All"
                                            })
                                        }, item.id),
                                        (item.items || []).map((subItem)=>{
                                            const { slug ="" , externalUrl =""  } = subItem;
                                            const contentProps = (0,getContentProps/* default */.Z)(subItem.sys_type, subItem.type);
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default.Link */.Z.Link, {
                                                    sx: {
                                                        fontColor: "2",
                                                        hover: {
                                                            fontColor: "white",
                                                            bgColor: "2"
                                                        }
                                                    },
                                                    href: contentProps && contentProps.alias ? "".concat(contentProps.alias, "/").concat(slug) : externalUrl,
                                                    children: subItem.title
                                                })
                                            }, subItem.sys_id);
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            }, item.id))
    });
};
HeroIconSectionOmiq.propTypes = {
    items: (0,prop_types.arrayOf)((0,prop_types.shape)({
        blockOrder: prop_types.number,
        id: prop_types.string,
        name: prop_types.string,
        items: (0,prop_types.arrayOf)((0,prop_types.shape)({
            title: prop_types.string,
            url: prop_types.string,
            externalUrl: prop_types.string,
            slug: prop_types.string,
            type: prop_types.string,
            sys_id: prop_types.string
        }))
    }))
};
/* harmony default export */ var IconSection_Omiq = (HeroIconSectionOmiq);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Link/index.js + 1 modules
var Link = __webpack_require__(25522);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Heading/index.js + 1 modules
var Heading = __webpack_require__(42866);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Resources/components/SectionHero/IconSection/Graphpad.js







const CardMini = (param)=>/*#__PURE__*/ {
    let { id , src , scrollTo , children  } = param;
    return (0,jsx_runtime.jsxs)(atomic_react_Grid/* Row */.X2, {
        py: true,
        className: "card-mini__image-block",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Col */.JX, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    href: "#".concat(id),
                    onClick: scrollTo,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: src
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Col */.JX, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                    sx: {
                        fontSize: "m"
                    },
                    spacing: {
                        mb: 0,
                        mt: "m7"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        href: "#".concat(id),
                        onClick: scrollTo,
                        color: "4",
                        hoverColor: "white",
                        children: children
                    })
                })
            })
        ]
    });
};
CardMini.propTypes = {
    id: prop_types.string.isRequired,
    src: prop_types.string.isRequired,
    children: prop_types.node.isRequired,
    scrollTo: prop_types.func.isRequired
};
const HeroIconSectionGraphpad = ()=>{
    const scrollToSection = (event)=>{
        event.preventDefault();
        const element = event.target;
        const isImg = element.tagName.toLowerCase() === "img";
        const href = isImg ? element.parentElement.getAttribute("href") : element.getAttribute("href");
        const id = href.substring(1, href.length);
        document.getElementById(id).scrollIntoView({
            behavior: "smooth"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(atomic_react_Grid/* Row */.X2, {
        className: "medium-up-2 large-up-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Col */.JX, {
                utility: {
                    align: {
                        self: "center"
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardMini, {
                    scrollTo: scrollToSection,
                    id: "getting-started",
                    src: "/images/graphpad/resources/tutorials.svg",
                    children: [
                        "Getting Started ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        " with Prism"
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Col */.JX, {
                utility: {
                    align: {
                        self: "center"
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardMini, {
                    scrollTo: scrollToSection,
                    id: "tutorials-guides",
                    src: "/images/graphpad/resources/guides.svg",
                    children: "Guides"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Col */.JX, {
                utility: {
                    align: {
                        self: "center"
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardMini, {
                    scrollTo: scrollToSection,
                    id: "academy",
                    src: "/images/graphpad/resources/prism-acad-i.svg",
                    children: "Prism Academy"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Col */.JX, {
                utility: {
                    align: {
                        self: "center"
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardMini, {
                    scrollTo: scrollToSection,
                    id: "quick-calcs",
                    src: "/images/graphpad/resources/quickcalcs.svg",
                    children: "QuickCalcs"
                })
            })
        ]
    });
};
/* harmony default export */ var IconSection_Graphpad = (HeroIconSectionGraphpad);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/PageNavbar/Link.js
var PageNavbar_Link = __webpack_require__(24661);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Resources/components/SectionHero/IconSection/Labarchives.js





const HeroIconSectionLabarchives = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageNavbar/* default */.Z, {
        alignHorizontal: "around",
        bgColor: "",
        fullWidthBorder: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageNavbar_Link/* default */.Z, {
                    href: "#eln",
                    children: "ELN"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageNavbar_Link/* default */.Z, {
                    href: "#inventory",
                    children: "Inventory"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageNavbar_Link/* default */.Z, {
                    href: "#scheduler",
                    children: "Scheduler"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageNavbar_Link/* default */.Z, {
                    href: "#eln-for-education",
                    children: "ELN for Education"
                })
            })
        ]
    });
};
/* harmony default export */ var IconSection_Labarchives = (HeroIconSectionLabarchives);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Resources/components/SectionHero/heroConfig.js
const heroConfig = {
    color: {
        sg: "black--02",
        gn: "transparent",
        gp: "gradient",
        om: "4",
        la: "4"
    },
    iconsInside: {
        sg: false,
        gn: true,
        gp: true,
        om: false,
        la: false
    }
};
/* harmony default export */ var SectionHero_heroConfig = (heroConfig);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Resources/components/SectionHero/SectionHero.js













const brandHeroTitle = {
    sg: Snapgene,
    om: Omiq,
    gp: Graphpad,
    la: Labarchives
};
const brandHeroIcons = {
    sg: IconSection_Snapgene,
    om: IconSection_Omiq,
    gp: IconSection_Graphpad,
    la: IconSection_Labarchives
};
const SectionHero = (param)=>{
    let { title , description , brandCode , items =[]  } = param;
    const FactoryHeroTitleSection = brandHeroTitle[brandCode];
    const FactoryHeroIconSection = brandHeroIcons[brandCode];
    const iconsInside = SectionHero_heroConfig.iconsInside[brandCode];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeroBrand/* default */.Z, {
                brandCode: brandCode,
                config: SectionHero_heroConfig,
                children: [
                    FactoryHeroTitleSection ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FactoryHeroTitleSection, {
                        title: title,
                        description: description
                    }) : null,
                    iconsInside && FactoryHeroIconSection ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FactoryHeroIconSection, {
                        items: items
                    }) : null
                ]
            }),
            !iconsInside && FactoryHeroIconSection ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FactoryHeroIconSection, {
                items: items
            }) : null
        ]
    });
};
SectionHero.propTypes = {
    title: prop_types.string.isRequired,
    description: prop_types.node.isRequired,
    brandCode: prop_types.string.isRequired,
    items: prop_types.array
};
/* harmony default export */ var SectionHero_SectionHero = (SectionHero);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Resources/components/SectionHero/index.js


// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/Apps/components/FeaturedContentBlock/FeaturedContentItems.js
var FeaturedContentItems = __webpack_require__(33120);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/LandingElement/SimpleSection.js
var SimpleSection = __webpack_require__(72989);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Resources/components/SectionResources/brand/Graphpad.js




const SectionResources = (param)=>{
    let { id , title , children , ...props } = param;
    const bgColor = id === "academy" ? "black--02" : "white";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SimpleSection/* default */.Z, {
        bgColor: bgColor,
        isBorderNone: true,
        id: id,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default.TitleV2 */.Z.TitleV2, {
                children: title
            }) : null,
            children
        ]
    });
};
SectionResources.propTypes = {
    id: prop_types.string.isRequired,
    title: prop_types.string,
    children: prop_types.node
};
/* harmony default export */ var brand_Graphpad = (SectionResources);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Resources/components/SectionResources/brand/Default.js




const Default_SectionResources = (param)=>{
    let { id , title ="" , children , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SimpleSection/* default */.Z, {
        bgColor: "white",
        id: id,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default.Title */.Z.Title, {
                children: title
            }) : null,
            children
        ]
    });
};
Default_SectionResources.propTypes = {
    id: prop_types.string.isRequired,
    title: prop_types.string,
    children: prop_types.node
};
/* harmony default export */ var Default = (Default_SectionResources);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/constants/index.js
var constants = __webpack_require__(34491);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Resources/components/SectionResources/SectionResources.js







const SectionResources_SectionResources = (param)=>{
    let { id , title , brandCode , Component =null , items =[] , ...props } = param;
    const SectionComponent = (brand)=>{
        switch(brand.toLowerCase()){
            case constants/* BRAND_CODE_GP */.yB:
                return brand_Graphpad;
            default:
                return Default;
        }
    };
    const itemsConfig = (brand)=>{
        switch(brand.toLowerCase()){
            case constants/* BRAND_CODE_OM */.h7:
                return {
                    isImgFluid: true,
                    withFilter: true
                };
            case constants/* BRAND_CODE_LA */.gf:
                return {
                    isImgFluid: true,
                    withFilter: false
                };
            default:
                return {
                    isImgFluid: false,
                    withFilter: false
                };
        }
    };
    const SectionBrand = SectionComponent(brandCode);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionBrand, {
        title: title,
        id: id,
        ...props,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedContentItems/* default */.Z, {
                items: items,
                ...itemsConfig(brandCode)
            }),
            Component ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {}) : null
        ]
    });
};
SectionResources_SectionResources.propTypes = {
    brandCode: prop_types.string,
    id: prop_types.string.isRequired,
    title: prop_types.string,
    Component: prop_types.elementType,
    items: prop_types.array
};
/* harmony default export */ var components_SectionResources_SectionResources = (SectionResources_SectionResources);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Resources/components/SectionResources/index.js


;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Resources/Page.js







const ResourcesPage = (param)=>{
    let { page , pageProps  } = param;
    const [t] = (0,i18/* useLocale */.bU)("resources");
    const { siteDomain , brandCode , customSections =[]  } = pageProps;
    const { sections  } = page;
    const list = [
        ...sections,
        ...customSections
    ];
    const sortSections = (a, b)=>{
        const sectionA = a.blockOrder;
        const sectionB = b.blockOrder;
        return sectionA < sectionB ? -1 : sectionA > sectionB ? 1 : 0; // eslint-disable-line
    };
    const listModified = (0,react.useMemo)(()=>list.sort(sortSections), [
        list,
        sortSections
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageMeta/* default */.ZP, {
                title: t("META_TITLE"),
                description: t("META_DESCRIPTION"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.OGP */.ZP.OGP, {
                        title: t("META_TITLE"),
                        description: t("META_DESCRIPTION"),
                        url: "".concat(siteDomain, "/resources")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Twitter */.ZP.Twitter, {
                        card: t("META_TWITTER_CARD"),
                        site: t("META_TWITTER_SITE"),
                        creator: t("META_TWITTER_CREATOR"),
                        title: t("META_TITLE"),
                        description: t("META_DESCRIPTION")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Canonical */.ZP.Canonical, {
                        href: "".concat(siteDomain, "/resources")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHero_SectionHero, {
                title: t("TITLE"),
                description: t("DESCRIPTION"),
                brandCode: brandCode,
                items: listModified
            }),
            listModified.map((pageSection)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(components_SectionResources_SectionResources, {
                    id: pageSection.id,
                    brandCode: brandCode,
                    title: pageSection.name,
                    items: pageSection.items,
                    Component: pageSection.Component,
                    ...pageSection.props
                }, pageSection.id))
        ]
    });
};
ResourcesPage.propTypes = {
    page: prop_types.object.isRequired,
    pageProps: (0,prop_types.shape)({
        resources: prop_types.any,
        siteDomain: prop_types.string
    })
};
/* harmony default export */ var Page = (ResourcesPage);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/Apps/components/FeaturedContentBlock/mapper.js
var mapper = __webpack_require__(4830);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/locales/index.js
var locales = __webpack_require__(5235);
var locales_default = /*#__PURE__*/__webpack_require__.n(locales);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Resources/index.js







const contentfulResourcesFactory = (param)=>{
    let { Layout , contentfulProps , pageProps  } = param;
    const ContentfulResourcesPage = (param)=>{
        let { page  } = param;
        const { brandCode , resources =null  } = pageProps;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(i18/* LocaleProvider */.Iw, {
                resources: resources || (locales_default())[brandCode],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Page, {
                    page: page,
                    pageProps: pageProps
                })
            })
        });
    };
    ContentfulResourcesPage.getInitialProps = async ()=>{
        const client = (0,createClient/* default */.Z)(contentfulProps);
        const { filter ={}  } = contentfulProps;
        const blockFeaturedContent = await client.getEntries({
            content_type: "blockFeaturedContent",
            ...filter
        });
        return {
            page: {
                sections: (0,mapper/* default */.Z)(blockFeaturedContent)
            }
        };
    };
    ContentfulResourcesPage.propTypes = {
        ...Page.propTypes
    };
    return ContentfulResourcesPage;
};
/* harmony default export */ var Resources = (contentfulResourcesFactory);


/***/ }),

/***/ 68103:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _insightfulscience_atomic_react_Hero__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69591);




const HeroBrand = (param)=>{
    let { brandCode ="sg" , config , children , ...props } = param;
    const { color  } = config;
    const brandColor = (brand)=>color[brand];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Hero__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        color: brandColor(brandCode),
        ...props,
        children: children
    });
};
HeroBrand.propTypes = {
    brandCode: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.oneOf)([
        "sg",
        "gp",
        "gn",
        "om",
        "la"
    ]),
    config: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.shape)({
        color: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.shape)({
            gn: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
            sg: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
            gp: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
            om: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
            la: prop_types__WEBPACK_IMPORTED_MODULE_3__.string
        })
    }),
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node
};
/* harmony default export */ __webpack_exports__["Z"] = (HeroBrand);


/***/ }),

/***/ 75833:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export pipeA */
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10455);

const pipe = function(value) {
    for(var _len = arguments.length, fns = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        fns[_key - 1] = arguments[_key];
    }
    return fns.reduce((val, fn)=>fn(val), value);
};
const pipeA = function(value) {
    for(var _len = arguments.length, fns = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        fns[_key - 1] = arguments[_key];
    }
    return fns.reduce((val, fn)=>(0,___WEBPACK_IMPORTED_MODULE_0__/* .isPromise */ .tI)(val) ? val.then(fn) : fn(val), value);
};
pipe.async = pipeA;
/* harmony default export */ __webpack_exports__["Z"] = (pipe);


/***/ }),

/***/ 73972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);



const Html = (param)=>/*#__PURE__*/ {
    let { Tag ="div" , children , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, {
        dangerouslySetInnerHTML: {
            __html: children
        },
        ...props
    });
};
Html.propTypes = {
    Tag: (0,prop_types__WEBPACK_IMPORTED_MODULE_2__.oneOfType)([
        prop_types__WEBPACK_IMPORTED_MODULE_2__.string,
        prop_types__WEBPACK_IMPORTED_MODULE_2__.element
    ]),
    children: prop_types__WEBPACK_IMPORTED_MODULE_2__.string
};
/* harmony default export */ __webpack_exports__["Z"] = (Html);


/***/ })

}]);